import styled from 'styled-components';
import React, { useEffect, useState } from "react";
import { Moment } from "moment/moment";
import moment from "moment";
import { DatePicker, Form } from "antd";
import useQuery from "../../hooks/useQuery";
import { SizeType } from "antd/lib/config-provider/SizeContext";

const Container = styled.div`
`;

interface YearSelectProps {
  formRef?: any;
  formItemStyle?: any;
  rules?: any;
  filter?: boolean;
  size?: SizeType;
}

function MonthSelect(props: YearSelectProps) {
  const { query, handleFilter } = useQuery();
  const { filter } = props;
  const [currentMoment, setCurrentMoment] = useState<Moment>();
  const queryValue = query.get('month') ? moment().set('month', Number(query.get('month'))) : undefined;

  const handleChange = (date: any) => {
    if (filter) {
      handleFilter('month', date ? date.month().toString() : null);
    } else {
      (props.formRef.current || props.formRef).setFieldsValue({ month: date.set('date', 1).toISOString().split("T")[0] });
      setCurrentMoment(date);
    }
  }

  useEffect(() => {
    if (!filter) {
      setTimeout(() => {
        if ((props.formRef.current || props.formRef).getFieldsValue().year) {
          setCurrentMoment(moment().set('month', props.formRef.current.getFieldsValue().month));
        }
      }, 250);
    }
  }, [props]);

  const MonthPickerComponent = DatePicker.MonthPicker as any;
  const select = (
    <MonthPickerComponent
      placeholder={filter ? 'Filter by month' : undefined}
      value={filter ? queryValue : currentMoment}
      onChange={handleChange}
      size={props.size}
    />
  )

  if (filter) return select;

  return (
    <Form.Item
      label="Month"
      key="month"
      name="month"
      style={props.formItemStyle}
      rules={props.rules}
    >
      <input type="hidden" name="month" />
      {select}
    </Form.Item>
  )
}

export default MonthSelect;
